import dateFormat from 'dateformat';
import { useEffect, useState } from 'react';

import { getAsync } from '../../../../../utils/api';
import { useFormSelector } from '../../../slice';

export default () => {
  const editingFormId = useFormSelector((state) => state.editingFormId);
  const [text, setText] = useState<string>();

  useEffect(() => {
    if (!editingFormId) {
      if (text) {
        setText(undefined);
      }

      return;
    }

    getAsync("/forms/get?id=" + editingFormId).then((res) => {
      if (!res.success) return;

      const { displayName } = res.data.account;
      const date = dateFormat(new Date(res.data.created), "dd/mm/yyyy HH:MM");

      setText(`${displayName} (${date})`);
    });
  }, [editingFormId]);

  return {
    value: text || editingFormId || "-",
  };
};
